import React from 'react';
import { useSimulationContext } from '../../providers/SimulationProvider';
import Character from './Character';

function CharactersContainer({ client }) {
  const { characterIds, selectedCharacterId } = useSimulationContext();

  if (!client) return null;

  return (
    <>
      {characterIds.map((characterId, index) => (
        <Character
          client={selectedCharacterId === characterId ? client : null}
          key={characterId}
          characterId={characterId}
          characterCount={characterIds.length}
          characterIndex={index}
        />
      ))}
    </>
  );
}

export default CharactersContainer;
